"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nativePaymentPropsGenerator = require("../../utils/native-payment/nativePaymentPropsGenerator");
var _fields = require("../fields");
var _reactIntl = require("react-intl");
var _FieldsForCountry = require("./FieldsForCountry");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var BillingAddressContainer = function BillingAddressContainer(props) {
  var _billingInfo$country;
  var _props$billingInfo = props.billingInfo,
    billingInfo = _props$billingInfo === void 0 ? {} : _props$billingInfo,
    _props$languageCode = props.languageCode,
    languageCode = _props$languageCode === void 0 ? '' : _props$languageCode,
    _props$countryCodes = props.countryCodes,
    countryCodes = _props$countryCodes === void 0 ? [] : _props$countryCodes,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    _props$statesResponse = props.statesResponse,
    statesResponse = _props$statesResponse === void 0 ? {} : _props$statesResponse,
    _props$billingContain = props.billingContainerRef,
    billingContainerRef = _props$billingContain === void 0 ? {} : _props$billingContain;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage,
    countryValue = billingInfo === null || billingInfo === void 0 || (_billingInfo$country = billingInfo.country) === null || _billingInfo$country === void 0 ? void 0 : _billingInfo$country.value;
  var selectedCountryFields = _FieldsForCountry.CountryFields[countryValue];
  selectedCountryFields = selectedCountryFields && selectedCountryFields.length ? selectedCountryFields : _FieldsForCountry.defaultCountryFields;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: billingContainerRef
  }, /*#__PURE__*/_react.default.createElement(_fields.Country, _extends({}, billingInfo.country, (0, _nativePaymentPropsGenerator.getCountryProps)(formatMessage), {
    locale: languageCode,
    countryCodes: countryCodes,
    onChange: onChange
  })), selectedCountryFields && selectedCountryFields.length && selectedCountryFields.map(function (rec, index) {
    var _billingInfo$country2;
    var Field = rec.field;
    var customProps = rec.name == 'zipCode' ? {
      customProps: {
        country: (billingInfo === null || billingInfo === void 0 || (_billingInfo$country2 = billingInfo.country) === null || _billingInfo$country2 === void 0 ? void 0 : _billingInfo$country2.value) || ''
      }
    } : {};
    var stateOptions = rec.isState ? {
      options: statesResponse
    } : {};
    return /*#__PURE__*/_react.default.createElement(Field, _extends({
      key: (rec === null || rec === void 0 ? void 0 : rec.name) || index
    }, rec['fieldProps'](formatMessage), billingInfo === null || billingInfo === void 0 ? void 0 : billingInfo[rec.name], customProps, {
      onChange: onChange
    }, stateOptions, {
      formatMessage: true
    }));
  }));
};
BillingAddressContainer.propTypes = {
  props: _propTypes.default.object,
  billingInfo: _propTypes.default.object,
  languageCode: _propTypes.default.string,
  countryCodes: _propTypes.default.array,
  onChange: _propTypes.default.func
};
var _default = BillingAddressContainer;
exports.default = _default;